// src/components/TestimonialsSlider.jsx
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";      // ✅ no slick-theme.css needed
import "@fortawesome/fontawesome-free/css/all.min.css";

const defaultTestimonials = [
  {
    img: "/images/1.png",
    text:
      "Staying at Shree Swami Samarth PG has been a wonderful experience. The rooms are always clean, food is freshly cooked, and the staff is polite and responsive. The PG is very secure, especially for female residents, with CCTV and biometric entry. Highly recommended for anyone working in Hinjewadi.",
    author: "Ms. Anjali Patil",
    designation: "Software Engineer, Infosys, Hinjewadi Phase 1",
  },
  {
    img: "/images/1.png",
    text:
      "I shifted to Shree Swami Samarth PG as a student and found it to be the most well-maintained place in the area. Fast Wi-Fi, peaceful environment for studying, and hygienic food made it feel like home. It’s also just a few minutes from my college, which is a big plus.",
    author: "Ms. Rutuja Deshmukh",
    designation: "MBA Student, Pune University",
  },
  {
    img: "/images/1.png",
    text:
      "As a working professional, I needed a PG near my office in Phase 2. This PG exceeded my expectations with clean AC rooms, regular laundry service, and home-like food. The team here is always ready to help. Totally value for money!",
    author: "Mr. Rohit Shinde",
    designation: "UI/UX Designer, Cognizant, Hinjewadi Phase 2",
  },
  {
    img: "/images/1.png",
    text:
      "The best part about Shree Swami Samarth PG is the location – walking distance from Capgemini and Infosys. I never have to worry about travel. The atmosphere is friendly, and the facilities are premium. You get everything – comfort, cleanliness, and safety.",
    author: "Ms. Priya Kulkarni",
    designation: "Business Analyst, Capgemini, Hinjewadi Phase 1",
  },
];


export default function TestimonialsSlider({ items = defaultTestimonials }) {
  const settings = {
    dots: true,
    arrows: false,          // simpler, avoids arrow font issues
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  return (
    <section className="testimonial-section">
      <div className="auto-container">
        {/* Sec Title */}
        <div className="sec-title centered">
          <h3>What our customers think about our services</h3>
          <div className="separator"></div>
        </div>
        {/* Slider */}
        <div className="single-item-carousel">
          <Slider {...settings}>
            {items.map((t, i) => (
              <div className="testimonial-block" key={i}>
                <div className="inner-box">
                  <div className="image">
                    <img src={t.img} alt={t.author} />
                  </div>
                  <div className="text">{t.text}</div>
                  <div className="quote-icon">
                    <span className="icon fas fa-quote-left"></span>
                  </div>
                  <div className="author">{t.author}</div>
                  <div className="designation">{t.designation}</div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
